var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimPLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 58,
    viewBox: "0 0 109 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.344 11.4V17.736H16.272V45H9.648V17.736H0.624V11.4H25.344Z",
    fill: "#2E375B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77 11.4V45H70.424V23.208L60.968 38.808H60.2L50.744 23.256V45H44.12V11.4H50.936L60.584 27.288L70.184 11.4H77Z",
    fill: "#2E375B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3943 11C31.5197 11 30 12.5197 30 14.3943V14.3943C30 16.2689 31.5197 17.7886 33.3943 17.7886H34.6057C36.4803 17.7886 38 16.2689 38 14.3943V14.3943C38 12.5197 36.4803 11 34.6057 11H33.3943Z",
    fill: "#E56A43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.0648V22.3548H38V19.0648H30Z",
    fill: "#E56A43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23.2449V26.5349H38V23.2449H30Z",
    fill: "#E56A43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.4431V30.7332H38V27.4431H30Z",
    fill: "#E56A43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.5894V45H38V31.5894H30Z",
    fill: "#E56A43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92.0657,
    y: 17,
    width: 7,
    height: 25,
    fill: "#E56A43"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 32.7561,
    width: 7,
    height: 25,
    transform: "rotate(-88.8846 83 32.7561)",
    fill: "#E56A43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 11.4V45H71.424V23.208L61.968 38.808H61.2L51.744 23.256V45H45.12V11.4H51.936L61.584 27.288L71.184 11.4H78Z",
    fill: "#2E375B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimPLogo);
export default __webpack_public_path__ + "static/media/timPLogo.53d1130f78332ded43e49d8976e345d4.svg";
export { ForwardRef as ReactComponent };